import { ptBr, en, es } from './locale';
import i18n from '@/main';

export const locale = {
    init: i18n => {
        i18n.mergeLocaleMessage('pt-BR', {
            laudos: {
                ...ptBr
            }
        });
        i18n.mergeLocaleMessage('en', {
            laudos: {
                ...en
            }
        });
        i18n.mergeLocaleMessage('es', {
            laudos: {
                ...es
            }
        });
    }
};

export const beforeEnter = (_to, _from, next) => {
    locale.init(i18n);
    next();
};
